module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (!_vm.paymentDone) ? _c('div', [_vm._m(1), _vm._v(" "), (_vm.$route.params.cart == 'VISA') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Help with your visa application file 120€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Help with your visa application file")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/contract.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'CRRV') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals 299€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals ")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/contract.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'TA') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Appeal to the Administrative Court of Nantes 299€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Appeal to the Administrative Court of Nantes")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/contract.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'PREMIUM') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Premium Pack 999€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("You are assisted and defended by a specialised lawyer.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/lawyer.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "light-frame visa-frame"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("We will send you the details of the procedure by email once you accept the engagement conditions")]), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onClickPay()
      }
    }
  }, [_c('span', [_vm._v("Pay")])])], 1)])], 1) : _c('div', [_c('h2', [_vm._v("Waiting for the International Express Money Order payment reception")]), _vm._v(" "), _c('p', [_vm._v("An confirmation email has just been sent to you")]), _c('p'), _c('p', [_vm._v("Once the International Express Money Order transfer made please follow the instruction that you received by email \n        To indicate the money order reference in order to finish to create your file.")]), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickContinue()
      }
    }
  }, [_vm._v("Continue")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "padding-bottom": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "40%",
      "max-width": "200px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/mandatexpress.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('h2', [_vm._v("Payment with International Express Money Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If you click on the “pay” button you accept to go  "), _c('u', [_vm._v("in a poste office ")]), _vm._v(" to make an International Express Money Order for the OCTAGRAM SAS account, GetMyVIsaToFrance operatore :")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "padding-left": "16px"
    }
  }, [_c('b', [_vm._v("Name of the company : OCTAGRAM SAS")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Adress : 59 rue Chardon Lagache 75016 Paris")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ab88264","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/CheckoutMandatExpress.vue
// module id = 729
// module chunks = 3